import { createAction } from 'redux-actions';

const showLoadingIndicator = createAction('LOADING_INDICATOR_SHOW', (data) => data);

const hideLoadingIndicator = createAction('LOADING_INDICATOR_HIDE', (data) => data);

export { showLoadingIndicator, hideLoadingIndicator };
